import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  background: rgba(10, 8, 8, 0.58);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 34px 30px 30px;

  @media (max-width: 640px) {
    padding: 18px 14px 170px;
    margin-top: 30px;
  }
`;

export const PopupBox = styled.div`
  width: min(460px, 100%);
  position: relative;
  background: #171414;
  border-radius: 26px;
  padding: 38px 30px 30px;
  text-align: center;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(201, 162, 39, 0.5);
  color: #fffaf3;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 16px;
  right: 18px;
  border: 0;
  background: transparent;
  font-size: 28px;
  cursor: pointer;
  color: rgba(255, 250, 243, 0.65);

  &:hover {
    color: #f58ab8;
  }
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #f58ab8;
  border-radius: 999px;
  padding: 0;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 18px;

  &::first-letter {
    color: #c9a227;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: #fffaf3;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 31px;
  font-weight: 400;
  line-height: 1.18;
  letter-spacing: 0.01em;

  span {
    color: #f58ab8;
  }
`;

export const Text = styled.p`
  margin: 18px auto 26px;
  max-width: 370px;
  color: rgba(255, 250, 243, 0.78);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 15px;
  line-height: 1.65;
`;

export const Form = styled.form`
  display: grid;
  gap: 12px;
`;

export const Input = styled.input`
  width: 100%;
  border: 1px solid rgba(201, 162, 39, 0.62);
  background: rgba(255, 255, 255, 0.02);
  color: #fffaf3;
  border-radius: 18px;
  padding: 15px 17px;
  font-size: 15px;
  outline: none;
  font-family: Georgia, "Times New Roman", serif;

  &::placeholder {
    color: rgba(255, 250, 243, 0.58);
  }

  &:focus {
    border-color: #d8b64c;
    box-shadow: 0 0 0 4px rgba(201, 162, 39, 0.12);
  }
`;

export const Button = styled.button`
  border: 1px solid rgba(201, 162, 39, 0.28);
  border-radius: 18px;
  padding: 15px 18px;
  background: #d97aa8;
  color: #fffaf3;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;

  &:hover {
    background: #cf6d9d;
    border-color: rgba(201, 162, 39, 0.45);
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

export const Success = styled.p`
  margin: 16px 0 0;
  color: #d8b64c;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
  line-height: 1.5;
`;

export const Error = styled.p`
  margin: 16px 0 0;
  color: #f58ab8;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
  line-height: 1.5;
`;

export const Logo = styled.img`
  width: 92px;
  height: auto;
  display: block;
  margin: 0 auto 14px;
  opacity: 0.92;
`;
